<template id="news">
	<div class="page page-news">
		<page-top></page-top>
		<div class="page-content">
			
			<div class="left">
				<div class="heading">NEWS</div>
				<div class="nav">
					<div class="nav-item" v-for="(news, i) in newsList"><a v-on:click="goto(i)">&gt;&nbsp;{{news.title}}</a></div>
				</div>
			</div>
			<div class="right">
				<div class="news-list">
					<div class="news" v-for="(news, i) in newsList" v-bind:name="'news-' + i" v-on:click="openNewsPopup(news)">
						<div class="time">{{news.create_time}}</div>
						<div class="horizontal-line">
							<div class="bg-left"></div>
							<div class="bg-center"></div>
							<div class="bg-right"></div>
						</div>
						
						<div class="title">{{news.title}}</div>
						<div class="desc" v-if="news.desc">{{news.desc}}</div>
					</div>
				</div>
			</div>
			

		</div>
		<page-bottom></page-bottom>
		<popup v-bind:html="newsPopupHtml" v-bind:show="newsPopupShow" v-on:before-close="newsPopupBeforeClose"></popup>
	</div>
</template>

<script>
import $ from 'jquery'
import NewsGenerator from '@/components/NewsGenerator'
export default {
	mounted: function() {

		if (!this.newsList.length) {
			this.axios.get('/news/getList').then((response) => {
				this.newsList = response.data
				global.newsList = response.data
			})
		}

	},
	data: function() {

		return {
			newsPopupShow: false,
			newsPopupHtml: '',
			newsPopupInterval: null,
			newsPopupCurrentNewsId: null,
			newsList: global.newsList || []
		}
	},
	methods: {
		goto: function(i) {
			$('body').animate({ scrollTop: $('[name="news-'+ i +'"]').offset().top - 20}, 600)
		},
		openNewsPopup: function(news) {

			this.newsPopupCurrentNewsId = news.id
			this.newsPopupHtml = ''
			this.newsPopupShow = true

			if (!news.content) {
				let fakeNews = {
					title: news.title,
					content: 'Loading...',
					create_time: news.create_time,
				}
				clearInterval(this.newsPopupInterval)
				this.newsPopupInterval = setInterval(() => {
					fakeNews.content += '.'
					this.newsPopupHtml = NewsGenerator(fakeNews)
				}, 500)
				this.axios.get(`/news/getData`, {
					params: {
						'id': news.id
					},
				}).then((response) => {
					news = response.data
					this.newsList.forEach(i => {
						if (i.id === news.id) {
							i.content = news.content
						}
					})
					global.newsList = this.newsList
					if (this.newsPopupCurrentNewsId === news.id) {
						var html = NewsGenerator(news);
						this.newsPopupHtml = html
						clearInterval(this.newsPopupInterval)
					}
				})
			} else {
				var html = NewsGenerator(news);
				this.newsPopupHtml = html
			}
		},
		newsPopupBeforeClose: function() {
			
			clearInterval(this.newsPopupInterval)
			this.newsPopupShow = false;
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/News.vue